import iconEdit from '@/assets/images/icon_edit.png'
import iconBak from '@/assets/images/icon_bak.png'
import iconAccess from '@/assets/images/icon_access.png'
import iconTemplate from '@/assets/images/icon_template.png'
import iconFolder from '@/assets/images/icon_folder.png'
import iconView from '@/assets/images/icon_view.png'

const icons = {
  edit: iconEdit,
  delete: iconBak,
  access: iconAccess,
  template: iconTemplate,
  folder: iconFolder,
  view: iconView
}

export default icons



// WEBPACK FOOTER //
// ./src/constants/images.js